import PricingComponent from 'components/Account/PricingComponent/PricingComponent';
import ContainerComponent from 'components/Tool/ContainerComponent/ContainerComponent';
import Footer from 'pages/Client/Footer/Footer';
import Header from 'pages/Client/Header/Header';
import './Pricing.css';

function Pricing() {
  return (
    <>
      <div className="pricing-page layout-full-height">
        <Header />

        <ContainerComponent className="layout-main-content">
          <>
            <PricingComponent />
          </>
        </ContainerComponent>

        <Footer />
      </div>
    </>
  );
}

export default Pricing;
